import { dispatch } from '../../jsCore/application/appStore'
import { CLASS_CONSTATNTS } from '../../jsCore/organizedByType/actions/analyticsActions'
import { COUNTRIES_IN_EUROPE, NO_LOCATION } from '../../jsCore/providers/geolocationProvider'

let consent
const INDEX = '10'
const OATH = '25'
const APP_NEXUS = '32'
const RHYTHM_ONE = '36'
const TABOOLA = '42'
const RUBICON = '52'
const THIRTY_THREE_ACROSS = '58'
const JUSTPREMIUM = '62'
const OPEN_X = '69'
const COMSCORE = '77'
const GROUP_M = '98'
const LOOP_ME = '109'
const SUBLIME = '114'
const DOUBLE_VERIFY = '126'
const INSKIN_MEDIA_LTD = '150'
const UNRULY = '162'
const SPOT_X = '165'
const COLLECTIVE_EUROPE = '179'
const TELARIA = '202'
const LKQD = '261'
const SIGNAL = '261'
const COMCAST = '285'
const SPRING_SERVE = '293'
const VIDIOLOGY = '309'
const CELTRA = '315'
const BROWSI = '329'
const BEACH_FRONT = '335'
const PLAYBUZZ = '444'
const PLAYGROUND = '490'

function parseConsent(data) {
  let minuteMediaVendorsIdList = [
    OPEN_X,
    INDEX,
    OATH,
    APP_NEXUS,
    TABOOLA,
    RUBICON,
    THIRTY_THREE_ACROSS,
    COMSCORE,
    GROUP_M,
    LOOP_ME,
    DOUBLE_VERIFY,
    INSKIN_MEDIA_LTD,
    SPOT_X,
    COLLECTIVE_EUROPE,
    SIGNAL,
    COMCAST,
    VIDIOLOGY,
    CELTRA,
    BROWSI,
    PLAYBUZZ,
    PLAYGROUND,
    SUBLIME,
    UNRULY,
    JUSTPREMIUM,
    LKQD,
    RHYTHM_ONE,
    TELARIA,
    SPRING_SERVE,
    BEACH_FRONT,
  ]
  let vendorListForGa = {}
  for (let [key, value] of Object.entries(data.vendorConsents)) {
    if (minuteMediaVendorsIdList.includes(key)) {
      vendorListForGa[key] = value
    }
  }
  let res = Object.keys(vendorListForGa).reduce(
    (all, key) => `${all}v_${key}=${data.vendorConsents[key] ? 1 : 0};`,
    ''
  )
  return Object.keys(data.purposeConsents).reduce(
    (all, key) => `${all}p_${key}=${data.purposeConsents[key] ? 1 : 0};`,
    res
  )
}

function getConsent() {
  window.__cmp('getConsentData', null, function(result) {
    localStorage.setItem('gdprApplies', result.gdprApplies)
    localStorage.setItem('consentData', result.consentData)
  })
  return new Promise(resolve =>
    window.__cmp('getVendorConsents', null, result => resolve(parseConsent(result)))
  )
}

function analyticsEvent(action, label) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: action,
        label: label,
      },
    },
  }
}

function pushConsentToDataLayer(consent) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'user consent status',
        label: ' ',
        cookieConsent: consent,
      },
    },
  }
}

function approveConsentLisnter() {
  window.__cmp('setConsentUiCallback', args => {
    if (args.uiShown) {
      consent.then(consentList => dispatch(analyticsEvent('consent banner ok click', consentList)))
    }
  })
}

let domClassWatcherInterval

const stopWatchingDomClass = () => {
  clearInterval(domClassWatcherInterval)
}

const watchDomClass = callback => {
  domClassWatcherInterval = setInterval(() => {
    const isShown = document.querySelector('.qc-cmp-ui-container.qc-cmp-showing')
    if (isShown) {
      stopWatchingDomClass()
      callback()
    }
  }, 1000)
}

export function init() {
  consent = getConsent()
  consent.then(consentList => {
    stopWatchingDomClass()
    localStorage.setItem('userConsent', consentList)
    dispatch(pushConsentToDataLayer(consentList))
  })
  approveConsentLisnter()
}

watchDomClass(() => {
  dispatch(analyticsEvent('consent banner impression', 'bottom sticky banner'))
  document.getElementById('qc-cmp-purpose-button').addEventListener('click', function() {
    dispatch(analyticsEvent('show purposes click', ' '))
    document
      .querySelectorAll('.qc-cmp-alt-action.qc-cmp-left-nav-link')[1]
      .addEventListener('click', function() {
        dispatch(analyticsEvent('see full vendor list click', ' '))
      })
    document
      .querySelector('.qc-cmp-alt-action.qc-cmp-left-nav-link.qc-cmp-back')
      .addEventListener('click', function() {
        dispatch(analyticsEvent('back to show purposes click', ' '))
      })
  })
})

//TEST CODE DO NOT DEL UNTIL QUANTCAST WILL RELEASE NEW VERSION
// const waitForCmpUi = () => {
//   const interval = setInterval( () => {
//     console.log('wating for cmpui');
//     if (window.__cmpui) {
//       debugger;
//       window.__myCmpui = {
//         ...{ __cmpui: window.__cmpui.bind(window) }
//       }.__cmpui;
//
//       window.__cmpui = (args) => {
//         debugger;
//         switch(args[0]) {
//           case 'updateConsentUi': {
//             dispatch(analyticsEventTest(showPurposePages[args[1]]))
//           }
//         }
//
//         window.__myCmpui(...args);
//       };
//       clearInterval(interval);
//     }
//   }, 300);
// };

// const showPurposePages = {
//   1: 'Main',
//   2: 'Show Purpose',
//   3: 'See full vendor list'
// };



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookie_consent/cookieConsentUtils.js